module.exports = __webpack_public_path__ + "456fbd5f.webp";